import { html as o, when as e } from "@microsoft/fast-element";
const r = o`
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.5 18.5C19.4107 18.5 20.2646 18.2565 21 17.8311V22L18.5 20.871L16 21.9768V17.8311C16.7354 18.2565 17.5893 18.5 18.5 18.5Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.5 19.25V17C14.5 16.8537 14.5209 16.7124 14.56 16.5787C13.8959 15.73 13.5 14.6612 13.5 13.5C13.5 10.7386 15.7386 8.5 18.5 8.5C19.6256 8.5 20.6643 8.87194 21.5 9.49963V4.625C21.5 3.58947 20.6605 2.75 19.625 2.75H3.375C2.33947 2.75 1.5 3.58947 1.5 4.625V17.375C1.5 18.4105 2.33947 19.25 3.375 19.25H14.5ZM5.75 6.75C5.33579 6.75 5 7.08579 5 7.5C5 7.91421 5.33579 8.25 5.75 8.25H14.25C14.6642 8.25 15 7.91421 15 7.5C15 7.08579 14.6642 6.75 14.25 6.75H5.75ZM5.75 9.75C5.33579 9.75 5 10.0858 5 10.5C5 10.9142 5.33579 11.25 5.75 11.25H11.5C11.9142 11.25 12.25 10.9142 12.25 10.5C12.25 10.0858 11.9142 9.75 11.5 9.75H5.75Z"
      fill="currentColor"
    />
    <path
      d="M18.5 17C16.6076 17 15.066 15.4982 15.0021 13.6214C15.0007 13.5811 15 13.5406 15 13.5C15 11.567 16.567 10 18.5 10C19.7605 10 20.8654 10.6663 21.4816 11.666C21.8103 12.1993 22 12.8275 22 13.5C22 15.433 20.433 17 18.5 17Z"
      fill="currentColor"
    />
  </svg>
`, l = o`
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.75 11.5L20.75 4.625C20.75 4.00368 20.2463 3.5 19.625 3.5L3.375 3.5C2.75368 3.5 2.25 4.00368 2.25 4.625L2.25 17.375C2.25 17.9963 2.75368 18.5 3.375 18.5L15.75 18.5M9.75 18.5L12.375 18.5M20.75 9.125L20.75 7.25"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.75 7.5L14.25 7.5M5.75 10.5L11.5 10.5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21 17.0006V22L18.5 20.8709L16 21.9768V17"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.5 18C20.433 18 22 16.433 22 14.5C22 12.567 20.433 11 18.5 11C16.567 11 15 12.567 15 14.5C15 16.433 16.567 18 18.5 18Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
`, t = o`
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.4167 15.6666C16.17 15.6666 16.8794 15.478 17.5 15.1454V18.3334L15.4166 17.3925L13.3333 18.3141V15.1453C13.9539 15.4779 14.6633 15.6666 15.4167 15.6666Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.8333 16.1667V14.1667C11.8333 14.0659 11.8433 13.9673 11.8623 13.8721C11.3204 13.1387 11 12.2317 11 11.2499C11 8.81066 12.9774 6.83325 15.4167 6.83325C16.3998 6.83325 17.3078 7.15445 18.0417 7.69762V3.85425C18.0417 2.92227 17.2861 2.16675 16.3542 2.16675H2.8125C1.88052 2.16675 1.125 2.92227 1.125 3.85425V14.4792C1.125 15.4112 1.88052 16.1667 2.8125 16.1667L11.8333 16.1667ZM5 5.25C4.58579 5.25 4.25 5.58579 4.25 6C4.25 6.41421 4.58579 6.75 5 6.75H11C11.4142 6.75 11.75 6.41421 11.75 6C11.75 5.58579 11.4142 5.25 11 5.25H5ZM5 8.25C4.58579 8.25 4.25 8.58579 4.25 9C4.25 9.41421 4.58579 9.75 5 9.75H9.05882C9.47304 9.75 9.80882 9.41421 9.80882 9C9.80882 8.58579 9.47304 8.25 9.05882 8.25H5Z"
      fill="currentColor"
    />
    <path
      d="M15.4167 14.1666C13.8397 14.1666 12.5551 12.9151 12.5017 11.3512C12.5006 11.3176 12.5 11.2838 12.5 11.2499C12.5 9.63909 13.8058 8.33325 15.4167 8.33325C16.5275 8.33325 17.4933 8.95423 17.9858 9.86797C18.2075 10.2793 18.3333 10.7499 18.3333 11.2499C18.3333 12.8607 17.0275 14.1666 15.4167 14.1666Z"
      fill="currentColor"
    />
  </svg>
`, n = o`
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.3334 12.5333C12.9361 12.5333 13.5035 12.3824 14 12.1163V14.6667L12.3333 13.914L10.6667 14.6512V12.1163C11.1632 12.3824 11.7306 12.5333 12.3334 12.5333Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.46667 12.9334V11.3334C9.46667 11.2527 9.47464 11.1739 9.48983 11.0976C9.05631 10.511 8.80002 9.78539 8.80002 8.99993C8.80002 7.04853 10.382 5.4666 12.3334 5.4666C13.1198 5.4666 13.8463 5.72356 14.4334 6.1581V3.0834C14.4334 2.33781 13.8289 1.7334 13.0834 1.7334H2.25003C1.50444 1.7334 0.900024 2.33781 0.900024 3.0834V11.5834C0.900024 12.329 1.50444 12.9334 2.25002 12.9334L9.46667 12.9334ZM4.00002 4.2C3.66865 4.2 3.40002 4.46863 3.40002 4.8C3.40002 5.13137 3.66865 5.4 4.00002 5.4H8.80002C9.1314 5.4 9.40002 5.13137 9.40002 4.8C9.40002 4.46863 9.1314 4.2 8.80002 4.2H4.00002ZM4.00002 6.6C3.66865 6.6 3.40002 6.86863 3.40002 7.2C3.40002 7.53137 3.66865 7.8 4.00002 7.8H7.24708C7.57845 7.8 7.84708 7.53137 7.84708 7.2C7.84708 6.86863 7.57845 6.6 7.24708 6.6H4.00002Z"
      fill="currentColor"
    />
    <path
      d="M12.3334 11.3333C11.0718 11.3333 10.0441 10.3321 10.0014 9.08098C10.0005 9.05408 10 9.02706 10 8.99993C10 7.71127 11.0447 6.6666 12.3334 6.6666C13.222 6.6666 13.9946 7.16338 14.3887 7.89438C14.566 8.22342 14.6667 8.59992 14.6667 8.99993C14.6667 10.2886 13.622 11.3333 12.3334 11.3333Z"
      fill="currentColor"
    />
  </svg>
`, s = o`
  ${e((C) => C._type === "outline", l)}
  ${e((C) => C._type === "solid", r)}
  ${e((C) => C._type === "mini", t)}
  ${e((C) => C._type === "micro", n)}
`;
export {
  s as licenseTemplate
};
